import { render, staticRenderFns } from "./YoutubePlayerWrapper.vue?vue&type=template&id=0c78013c"
import script from "./YoutubePlayerWrapper.vue?vue&type=script&lang=js"
export * from "./YoutubePlayerWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c78013c')) {
      api.createRecord('0c78013c', component.options)
    } else {
      api.reload('0c78013c', component.options)
    }
    module.hot.accept("./YoutubePlayerWrapper.vue?vue&type=template&id=0c78013c", function () {
      api.rerender('0c78013c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/watchTogether/ongoing/videoProviderWrappers/YoutubePlayerWrapper.vue"
export default component.exports